/**
 * Вход в систему и текущая сессия.
 *
 * Токенов в ответе нет: сессия живёт в httpOnly + Secure + SameSite=Strict
 * cookie, которую браузер сам шлёт и на HTTP, и на handshake WebSocket (§8.1).
 * Роль клиент не присылает никогда — она читается из сессии на сервере.
 */
import { z } from 'zod';
import { bigIdSchema, roleSchema } from './common.dto.js';
export const loginBodySchema = z.object({
    login: z.string().min(1).max(64),
    password: z.string().min(8).max(200),
});
/** То, что можно показать самому пользователю и положить в состояние SPA */
export const sessionUserSchema = z.object({
    id: bigIdSchema,
    login: z.string(),
    fullName: z.string(),
    role: roleSchema,
    /** Есть ли у диспетчера заведённый SIP-аккаунт: без него пульт не звонит */
    hasSipAccount: z.boolean(),
});
export const loginResponseSchema = z.object({ user: sessionUserSchema });
/** GET /api/auth/me — источник роли для роутинга SPA */
export const meResponseSchema = z.object({ user: sessionUserSchema });
/** Смена собственного пароля: старый обязателен, сброс делает админ отдельно */
export const changePasswordBodySchema = z.object({
    currentPassword: z.string().min(8).max(200),
    newPassword: z.string().min(10).max(200),
});
//# sourceMappingURL=auth.dto.js.map